import { render, staticRenderFns } from "./CarouselPhotoGallery.vue?vue&type=template&id=77f9b863&"
import script from "./CarouselPhotoGallery.vue?vue&type=script&lang=js&"
export * from "./CarouselPhotoGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports